import React, { useEffect, useState } from 'react';
import { Button, Grid, Typography, Paper, Input } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import { documentFileSearch, documentTemplate, documentsSearch, loginCnss } from '../../action';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { GedToken } from '../../utils/constant';
import DocumentViewDialog from '../DocumentViewDailog/DocumentView';
import { decodeId } from '../../utils/helper';

const PaymentDocuments = ({ paymentDetail, snackbarOpen }) => {
    const fileData = useSelector((state) => state.profileReducer);
    const documentData = useSelector((state) => state.profileReducer?.documentData);
    const FileSearch = useSelector((state) => state.profileReducer?.fileData);
    const [blobUrl, setBlobURL] = useState();
    const [documentView, setDocumentView] = useState(false);
    const [docUploadStatus, setDocUpdateStatus] = useState(false)
    const { t } = useTranslation();
    const dispatch = useDispatch();
    useEffect(() => {
        loginCnss();
        dispatch(documentTemplate("payment"));
    }, []);
    useEffect(() => {
        dispatch(documentsSearch({ requestNumber: `${paymentDetail?.paymentCode}` }));
        dispatch(documentFileSearch({ requestNumber: `${paymentDetail?.paymentCode}` }))
    }, [paymentDetail?.paymentCode, docUploadStatus, snackbarOpen]);

    const handleDocumentUpload = (index, file) => {
        let name = "";
        let previousDocId = "";
        fileData?.templateData?.forEach((item, ind) => {
            if (ind === index) {
                name = item?.name;
                documentData?.forEach((docId) => {
                    if (item.name === docId.documentName) {
                        previousDocId = docId?.id;
                    }
                });
            }
        });
        const formData = new FormData();
        formData.append('file', file);
        formData.append('previousDocId', previousDocId);
        formData.append('fileId', FileSearch?.[0].id);
        formData.append('documentName', name);
        formData.append('isAdditionalFlow', false);
        const apiUrl = `${process.env.REACT_APP_GED_URL}/documents/upload`;
        const headers = {
            Authorization: `Bearer ${GedToken}`,
        };
        fetch(`${apiUrl}`, {
            method: "POST",
            headers: headers,
            body: formData,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((res) => {
                const resUpload = res;
                console.log("resUpload", resUpload);
                setDocUpdateStatus(true)
            })
            .catch((error) => {
                console.error("API request error:", error);
            });


    };

    console.log(paymentDetail, 'paymentDetail');
    const handleDocumnetView = (document) => {
        const apiUrl = `${process.env.REACT_APP_GED_URL}/documents/get`;
        const headers = {
            Authorization: `Bearer ${GedToken}`,
            "Content-Type": "application/json",
        };

        fetch(`${apiUrl}?documentUuid=${document?.documentId}`, {
            method: "POST",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.blob();
            })
            .then((blob) => {
                const pdfUrl = URL.createObjectURL(blob);
                setBlobURL(pdfUrl);
                setDocumentView(true)
            })
            .catch((error) => {
                console.error("API request error:", error);
            });
    };
    return (
        <Grid container>
            <Grid style={{ display: "flex", width: "94%", marginLeft: "1.1rem",paddingLeft:".5rem",paddingRight:"1rem" ,backgroundColor: "#F2F9F5", justifyContent: "space-between" }}>
                <Typography variant="h6">{t("Name")}</Typography>
                <Typography variant="h6">Action</Typography>
            </Grid>
            {fileData?.templateData?.map((template, index) => (
                <Grid container style={{ margin: ".5rem .5rem .5rem .5rem",width:"100%",display:"flex",justifyContent:"space-between" }} item key={template.id} alignItems="center" spacing={2}>
                    <Grid item>
                        <Typography>{t(template.name)}</Typography>
                    </Grid>
                    <Grid item>
                        {documentData && documentData?.find(doc => doc?.documentName === template.name) ? (
                            <Button
                                // variant="contained"
                                color="primary"
                                startIcon={<InsertDriveFileIcon />}

                                onClick={() => {
                                    const selectedDocument = documentData.find(doc => doc.documentName === template.name);
                                    handleDocumnetView(selectedDocument);
                                }}

                            >

                            </Button>
                        ) : (
                            <label htmlFor={`file-upload-${template.id}`}>
                                <input
                                    id={`file-upload-${template.id}`}
                                    style={{ display: "none" }}
                                    type="file"
                                    accept=".pdf"
                                    disabled={paymentDetail?.status == '5' || paymentDetail?.status == '3'}
                                    onChange={(event) => handleDocumentUpload(index, event.target.files[0])}
                                />
                                <Button
                                    component="span"
                                    color="primary"
                                    variant="contained"
                                    disabled={paymentDetail?.status == '5' || paymentDetail?.status == '3'}
                                >
                                    {t("Browse")}
                                </Button>
                            </label>
                        )}
                    </Grid>
                </Grid>
            ))}
            {documentView && <DocumentViewDialog blobUrl={blobUrl} documentView={documentView} setDocumentView={setDocumentView} />}
        </Grid>
    );
};

export default PaymentDocuments;
